import React from 'react';
import Text from 'components/_UI/Text';
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import EventCardV2 from '../card/EventCardV2';

export default function MultipleEventsListV2({ data, onEventClick }) {
    const address = data?.[0]?.address;
    const addressLabel = [
        address?.street?.name && `Rua ${address.street.name}`,
        address?.street?.district && `bairro ${address.street.district}`,
    ].filter(Boolean).join(', ');

    return (
        <Container>
            {addressLabel && (
                <Text type='bold' color={colors.nightDark} paddingBottom='16px'>
                    {addressLabel}
                </Text>
            )}
            <CardsContainer>
                {data?.map((event) => (
                    <EventCardV2
                        key={event.slug}
                        data={event}
                        whiteBackground
                        onEventClick={() => onEventClick(event)}
                    />
                ))}
            </CardsContainer>
        </Container>
    );
}

const Container = styled(Column)`
    width: 100%;
    padding: 16px;
`;

const CardsContainer = styled(Column)`
    width: 100%;

    & > div {
        margin-top: 12px;
    }

    & > div:first-child {
        margin-top: 0;
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
        flex-wrap: wrap;

        & > div {
            width: 31%;
            margin-left: 1.5%;
            margin-top: 16px;
        }

        & > div:nth-child(3n+1) {
            margin-left: 0;
        }

        & > div:first-child {
            margin-top: 0;
        }
    }
`;
